import React from 'react';
import PropTypes from 'prop-types';
import './packetUploadTooltip.scss';

const PacketUploadTooltip = ({ status, iconSize }) => (
  <div className="packet-upload-tooltip" style={{ '--packet-icon-size': `${iconSize}px` }}>
    <strong>{status.label}</strong>
    <ul>
      {status.parts.map((part) => (
        <li key={part.index}>
          <span className="packet-upload-tooltip__icon" aria-hidden="true">{part.status.iconNode}</span>
          <div>
            <strong>{part.title}</strong>
            {part.detail && <div className="packet-upload-tooltip__metadata">{part.detail}</div>}
            <div>{part.summary}</div>
          </div>
        </li>
      ))}
    </ul>
  </div>
);

PacketUploadTooltip.propTypes = {
  status: PropTypes.shape({
    label: PropTypes.string.isRequired,
    parts: PropTypes.arrayOf(PropTypes.shape({
      index: PropTypes.number.isRequired,
      title: PropTypes.string.isRequired,
      detail: PropTypes.string,
      summary: PropTypes.string.isRequired,
      status: PropTypes.shape({ iconNode: PropTypes.node.isRequired }).isRequired,
    })).isRequired,
  }).isRequired,
  iconSize: PropTypes.number,
};
PacketUploadTooltip.defaultProps = { iconSize: 22 };

export default PacketUploadTooltip;
